export default "__VITE_ASSET__6a5bd4d1__"